<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Add Branded Host</v-card-title>

        <v-card-text>

            <v-row>
                <v-col>
                    <v-text-field
                        label="Host"
                        autofocus
                        v-model="host"
                        v-on:input="checkHostAvailable"
                        autocomplete="off"
                    />
                </v-col>
                <v-col>
                    <v-select
                        label="Domain"
                        :items="domains"
                        v-model="domain"
                        v-on:change="checkHostAvailable"
                    />
                </v-col>
            </v-row>

            {{preview}}

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            host: null,
            domain: null,
            checked_ok_to_put: 'not-ok',
        }
    },

    methods: {

        checkHostAvailable: _.debounce(function(){
            this.checked_ok_to_put = 'checking';
            this.doCheckHostAvailable();
        }, 751),
        
        doCheckHostAvailable()
        {
            let host = this.createHost();

            if ( host == null )
            {
                this.checked_ok_to_put = 'not-ok';
                return;
            }
            
            this.$rc.rest(
                'PUT: /api/v1/branded-link-shortener/settings/check-put-host',
            
                host,
            
                (data) => {
                   this.checked_ok_to_put = data.is_ok ? 'ok' : 'not-ok';
                },
            
                () => {
                    this.$rc.alert('Error','Unable to check that host is available');
                },
            );
        },
        

        showDialog()
        {
            this.dialog = true;
            this.host = null;
            this.domain = null;
        },

        onOk()
        {
            this.dialog = false;

            this.$emit(
                'add-host',
                this.createHost()
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

        isValidHost()
        {
            if ( this.host == null ) return false;

            let val = this.host.trim();
            if ( val.length == 0 || val.length > 63 ) return false;

            const regex = /^[-A-Za-z0-9]+$/;

            return val.match(regex) != null;
        },

        createHost()
        {
            if ( !this.isValidHost() ) return null;
            if ( this.domain == null ) return null;

            return {
                'organization_id': this.$route.params.organization_id,
                'host': this.host.trim().toLowerCase()+"."+this.domain,
                'is_active': true,
            };
        }
    },

    computed: {
        domains() {
            return this.$rc.enumValues('short_link_domain')
                .filter(d => d.active);
        },

        preview() {
            if ( this.host == null || this.host.trim().length == 0 )
                return 'Please enter a host';

            if ( this.isValidHost() == false )
                return 'Your host name is not valid.  Host names may only contain letters, numbers and dashes.';

            if ( this.domain == null )
                return 'Please choose a domain';

            if ( this.checked_ok_to_put == 'checking' )
                return 'Checking to make sure host is available';

            if ( this.checked_ok_to_put == 'not-ok' )
                return 'Host is used by another organization';

            return 'Example short link: https://'+this.host.toLowerCase()+"."+this.domain+'/57YZIcZq';
        },

        is_valid() {
            return this.createHost() != null && this.checked_ok_to_put == 'ok';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>